export type SegmentType = "text" | "mention" | "hashtag" | "url"

export interface TextSegment {
  type: SegmentType
  value: string
}

const TOKEN_PATTERN = /@\w+|#\w+|https?:\/\/[^\s<]+/g
const URL_TRAILING_PUNCTUATION = /[.,;:!?)\]}'"]+$/

export function parseTextSegments(text: string): TextSegment[] {
  const segments: TextSegment[] = []
  let lastIndex = 0

  for (const match of text.matchAll(TOKEN_PATTERN)) {
    const matchStart = match.index
    if (matchStart > lastIndex) {
      segments.push({ type: "text", value: text.slice(lastIndex, matchStart) })
    }

    const raw = match[0]
    if (raw.startsWith("@")) {
      segments.push({ type: "mention", value: raw })
      lastIndex = matchStart + raw.length
    } else if (raw.startsWith("#")) {
      segments.push({ type: "hashtag", value: raw })
      lastIndex = matchStart + raw.length
    } else {
      const trimmed = raw.replace(URL_TRAILING_PUNCTUATION, "")
      segments.push({ type: "url", value: trimmed })
      lastIndex = matchStart + trimmed.length
    }
  }

  if (lastIndex < text.length) {
    segments.push({ type: "text", value: text.slice(lastIndex) })
  }

  return segments
}
